import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { CheckCircleIcon } from '@/components/icons';
import { SecretReveal } from '@/components/SecretReveal';
import { AGENT_TOKEN_ENV } from './AgentTokenSection';

export interface NodeCreatedViewProps {
  isOpen: boolean;
  onClose: () => void;
  nodeName: string;
  /** Agent API token returned by the create call - shown only here, once */
  token: string;
}

/**
 * Success screen after creating a node, showing its agent token once
 */
export function NodeCreatedView({ isOpen, onClose, nodeName, token }: NodeCreatedViewProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Node Created Successfully"
      size="md"
      footer={<Button onClick={onClose}>Done</Button>}
    >
      <div className="node-modal-success">
        <div className="node-modal-success-icon">
          <CheckCircleIcon size={null} />
        </div>
        <p className="node-modal-success-text">
          Your node <strong>{nodeName}</strong> has been created.
        </p>
        <SecretReveal
          value={token}
          label={
            <>
              Agent API token - it will only be shown once. Set it as <code>{AGENT_TOKEN_ENV}</code> in
              the node agent environment (e.g. <code>/opt/cdn-node-agent/.env</code>) and restart the
              agent.
            </>
          }
        />
      </div>
    </Modal>
  );
}
